var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgStor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8824 28.6975L39.894 25.8149L35.7897 29.7847L39.5399 33.4141L44.8824 30.3283C45.0263 30.2465 45.146 30.1278 45.2289 29.9845C45.3119 29.8413 45.3553 29.6785 45.3546 29.5129C45.3558 29.3468 45.3126 29.1835 45.2296 29.0397C45.1466 28.8959 45.0268 28.7768 44.8824 28.6948V28.6975ZM39.0485 25.3207L33.5577 22.1498L21.5219 15.9727L35.1116 29.1313L39.0485 25.3207ZM21.7251 43.4018L33.5769 36.8623L38.6943 33.9055L35.1143 30.4381L21.7251 43.4018ZM20.7203 16.508L20.7065 43.0751L34.439 29.7847L20.7203 16.508Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9915 0.501419C13.9657 0.501419 0.982971 13.486 0.982971 29.51C0.982971 45.534 13.9676 58.5186 29.9915 58.5186C46.0174 58.5186 59.0001 45.534 59.0001 29.51C59.0001 13.486 46.0155 0.501419 29.9915 0.501419ZM55.2571 29.51C55.2571 43.3948 44.0167 54.7755 29.9915 54.7755C16.1067 54.7755 4.72601 43.5352 4.72601 29.51C4.72601 15.6252 15.9664 4.24446 29.9915 4.24446C43.8764 4.24446 55.2571 15.4848 55.2571 29.51Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStor);
export default __webpack_public_path__ + "static/media/BGStor.db895fe2f79e4f4272fb1a3bcb554c67.svg";
export { ForwardRef as ReactComponent };